import React, { createContext, useMemo, useState } from "react";

export const QuestionarioContext = createContext({});

export function QuestionarioProvider({ children }) {
  const [listaQuestionarios, setListaQuestionarios] = useState([]);

  const adicionarQuestionario = (data) => {
      setListaQuestionarios((current) => {
          return [data, ...current];
      });
  };

  const atualizarQuestionario = (data) => {
      setListaQuestionarios((current) => {
          return current.map((questionario) => {
              if (questionario.id_questionario === data.id_questionario) {
                  return data;
              }
              return questionario;
          });
      });
  };

  const removerQuestionario = (idQuestionario) => {
      setListaQuestionarios((current) => {
          return current.filter(
              (questionario) => questionario.id_questionario !== idQuestionario
          );
      });
  };

  const atualizarPergunta = (perguntaAtualizada) => {
      setListaQuestionarios((current) => {
          return current.map((questionario) => {
              if (questionario.id_questionario === perguntaAtualizada.id_questionario) {
                  let temp = questionario.perguntas?.map((pergunta) => {
                      if (pergunta.id_pergunta === perguntaAtualizada.id_pergunta) {
                          return perguntaAtualizada;
                      } else {
                          return pergunta;
                      }
                  });
                  questionario.perguntas = temp;
              }
              return questionario;
          });
      });
  }

  const adicionarPergunta = (idQuestionario, perguntas) => {
      setListaQuestionarios((current) => {
          return current.map((questionario) => {
              if (questionario.id_questionario == idQuestionario) {
                  if (questionario.perguntas?.length) {
                      questionario.perguntas = [...questionario.perguntas, ...perguntas];
                  } else {
                      questionario.perguntas = perguntas;
                  }
              }
              return questionario;
          })
      })
  }

  const removerPergunta = (perguntaRemover) => {
      setListaQuestionarios((current) => {
          return current.map((questionario) => {
              if (questionario.id_questionario === perguntaRemover.id_questionario) {
                  let temp = questionario.perguntas?.filter((pergunta) => pergunta.id_pergunta !== perguntaRemover.id_pergunta);
                  questionario.perguntas = temp;
              }
              return questionario;
          });
      })
  }
  
  const values = useMemo(()=>{
    return {
      listaQuestionarios,
      setListaQuestionarios,
      adicionarPergunta, 
      adicionarQuestionario,
      removerPergunta,
      atualizarPergunta,
      removerQuestionario,
      atualizarQuestionario,
    }
  },[listaQuestionarios])

  return (
    <QuestionarioContext.Provider value={values}>
      {children}
    </QuestionarioContext.Provider>
  )
}
